/**
 * The full list of pending changes, for when there are more than fit in the
 * menu panel. Read-only per line — applying is all-or-nothing — with Apply
 * here too so you don't have to go back to the menu.
 */
import type { ChangeGroup } from '@/components/trips/changeSummary';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { RefreshCw } from 'lucide-react';

export function ChangesDialog({
  open,
  onOpenChange,
  groups,
  count,
  applying,
  onApply,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  groups: ChangeGroup[];
  count: number;
  applying: boolean;
  onApply: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[85dvh] flex-col gap-3 p-0 sm:max-w-lg">
        <DialogHeader className="px-5 pt-5">
          <DialogTitle>
            {count} {count === 1 ? 'change' : 'changes'} waiting
          </DialogTitle>
          <DialogDescription>
            Nothing on your board moves until you apply. Applied changes stay highlighted on the
            board until you clear them.
          </DialogDescription>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-y-auto px-3">
          {groups.map((group) => (
            <div key={group.listKey} className="mb-3">
              <p className="px-2 pb-1 text-[var(--muted-foreground)] text-xs">{group.listName}</p>
              {group.lines.map((line) => (
                <p key={line.key} className="px-2 py-1.5 text-sm leading-snug">
                  {line.text}
                </p>
              ))}
            </div>
          ))}
        </div>
        <DialogFooter className="border-[var(--border)] border-t px-5 py-3">
          <Button type="button" onClick={onApply} disabled={applying}>
            <RefreshCw className={applying ? 'animate-spin' : undefined} />
            {applying ? 'Applying…' : `Apply ${count} ${count === 1 ? 'change' : 'changes'}`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
